module.exports = __webpack_public_path__ + "img/liangcong.172cb12e.jpg";